import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import RgaSearchSelectedDomains from '../state/selected-domains';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateRgaSearchSelectedDomains = (state, action) => {

    const properties = action.property.split('.');

    if (action.property.split('.').length > 1) {

        const [domain, subDomain] = properties;

        return RgaSearchSelectedDomains.update(state, {
            [domain]: {
                [subDomain]: {
                    $set: action.value
                }
            }
        });

    }

    return RgaSearchSelectedDomains.update(state, {
        [properties[0]]: {
            $set: action.value
        }
    });

};

const resetRgaSearchFormSelectedDomains = state => RgaSearchSelectedDomains.update(state, {
    analysisStatus: {
        $set: new KeyValuePair({key: '', value: ''})
    },
    requesterType: {
        $set: new KeyValuePair({key: '', value: ''})
    },
    rgaRecallStatus: {
        currentStatus: {
            $set: new KeyValuePair({key: '', value: ''})
        },
        genericStatus: {
            $set: new KeyValuePair({key: '', value: ''})
        },
        infoReqStatus: {
            $set: new KeyValuePair({key: '', value: ''})
        },
        partReqStatus: {
            $set: new KeyValuePair({key: '', value: ''})
        },
        photoReqStatus: {
            $set: new KeyValuePair({key: '', value: ''})
        }
    },
    rgaUnits: {
        $set: new KeyValuePair({key: '', value: ''})
    }
});

export default (state = getDefaultState().rgaSearchSelectedDomains, action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_SEARCH_SELECT_DOMAIN_VALUE]: updateRgaSearchSelectedDomains,
        [actions.RESET_RGA_SEARCH_FORM_SELECTED_DOMAINS]: resetRgaSearchFormSelectedDomains

    };

    const reducer = actionTypes[action.type];

    return reducer ? reducer(state, action) : state;

};



// WEBPACK FOOTER //
// ./src/rga/search/reducers/rga-domain-values.js